import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MaterialModule, ReusableHeaderBreadcrumbContainerModule, SharedModule } from "@app/shared";
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import {
  AddRawLeadsNotesModalComponent,
  RawLeadAddEditComponent,
  RawLeadImportFailedListCompenent,
  RawLeadListComponent,
  RawLeadUploadComponent,
  RawLeadViewComponent
} from '@sales/components/raw-lead';

const routes: Routes = [
  { path: '', component: RawLeadListComponent, data: { title: 'Unqualified Lead' }, canActivate: [AuthGuard] },
  { path: 'add-edit', component: RawLeadAddEditComponent, data: { title: 'Unqualified Lead Add/Edit' }, canActivate: [AuthGuard] },
  { path: 'view', component: RawLeadViewComponent, data: { title: 'Unqualified Lead View' }, canActivate: [AuthGuard] },
  { path: 'upload', component: RawLeadUploadComponent, data: { title: 'Unqualified Lead upload' }, canActivate: [AuthGuard] },
  { path: 'import-failed', component: RawLeadImportFailedListCompenent, data: { title: 'Unqualified Lead Import Failed' }, canActivate: [AuthGuard] },
];
@NgModule({
  declarations: [RawLeadAddEditComponent, RawLeadImportFailedListCompenent, RawLeadListComponent, RawLeadUploadComponent, RawLeadViewComponent,
    AddRawLeadsNotesModalComponent],
  imports: [
    SharedModule,ReusableHeaderBreadcrumbContainerModule,
    RouterModule.forChild(routes), MaterialModule
  ],
  entryComponents: [AddRawLeadsNotesModalComponent]
})
export class RawLeadModule { }
